<template>
  <div class="container-violation" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.Violation.k006') }}</span>
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules01.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="week-data-box">
      <div class="week-data">
        <div class="data">
          <div class="num">
            <img class="img1" src="@/assets/packageAssets/views/P2_Page/Violation/default/girl.webp" alt="" />
            {{ totalVioWeek }}
          </div>
          <div class="text">{{ $t('lang.Violation.k005') }}</div>
        </div>
        <span class="line"></span>
        <div class="data">
          <div class="num">
            <img class="img2" :src="getMatchImg('beans')" alt="" />
            {{ totalDedWeek }}
          </div>
          <div class="text">{{ $t('lang.Violation.k004') }}</div>
        </div>
      </div>
    </div>

    <div class="list-tit">{{ $t('lang.BaseCommon.k050') }}</div>
    <div class="list-search-box">
      <div class="search-input">
        <input v-model="hostId" :placeholder="$t('lang.Violation.k002')" class="input" type="text" />
        <img @click="handleSearch(hostId)" class="search-icon" src="@/assets/packageAssets/views/P2_Page/Violation/default/search_black.webp" alt="" />
      </div>
      <div class="search-select" @click="handleTimePop">
        <span v-if="chooseTime">{{ handleMoment(chooseTime, 'YYYY-MM-DD') }}</span>
        <span v-else>{{ $t('lang.BaseCommon.k034') }}</span>
        <img :class="{ activeTime: showPop }" src="@/assets/packageAssets/common/arrow06.webp" alt="" />
      </div>
      <div class="refresh" @click="handleClear">
        <img src="@/assets/packageAssets/views/P2_Page/Violation/default/refresh.webp" alt="" />
      </div>
    </div>
    <div class="list-header">
      <div class="tableName" v-for="(item, index) in tableName" :key="index">{{ item }}</div>
    </div>

    <van-list
      class="list-data-box"
      v-model="loading"
      :finished="finished"
      loading-text=" "
      :finished-text="$t('lang.BaseCommon.k087')"
      offset="200"
      @load="onLoad"
    >
      <div class="list-data" v-for="(item, index) in listData" :key="index">
        <div class="avatar-box">
          <img class="avatar" :src="item.avatar | imgPath" alt="" />
          <div class="copy-id" @click="copyId(item.presentId)">
            <span class="id">{{ item.presentId }}</span>
            <img class="copy" src="@/assets/packageAssets/views/P2_Page/Violation/default/copy_pink.webp" alt="" />
          </div>
        </div>
        <div class="opinion">
          {{ item.punishReason }}
        </div>
        <div class="time">
          {{ handleMoment(item.punishTime, 'YYYY-MM-DD') }}
        </div>
        <div class="beans-num">
          {{ item.punishAmount }}
          <img class="beans" :src="getMatchImg('beans')" alt="" />
        </div>
      </div>
      <div v-if="listData && !listData.length" style="width: 100%; height: 100px"></div>
    </van-list>

    <CTimeDay :showPop="showPop" :min-date="minDate" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import { apiFetchVioData } from '@/api/imee'
import CTimeDay from '@/components/CTimeDay'
import { getBaseFeature } from '@/assets/style/variable'

export default {
  components: { CTimeDay },
  props: {},
  data() {
    return {
      showPop: false,
      listQuery: {
        offset: 0,
        limit: 5,
      },
      hostId: null,
      chooseTime: null,
      minDate: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000),

      tableName: [this.$t('lang.BaseCommon.k103'), this.$t('lang.BaseCommon.k048'), this.$t('lang.Violation.k003'), this.$t('lang.Violation.k001')],
      selectText: this.$t('lang.BaseCommon.k003'),
      selectList: [this.$t('lang.BaseCommon.k003'), this.$t('lang.BaseCommon.k034'), this.$t('lang.BaseCommon.k042')],
      listData: [],
      loading: false,
      finished: false,
      list: [],
      totalDedWeek: 0,
      totalVioWeek: 0,
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    handleBack() {
      // 代理中心v1.0增加逻辑
      const fromPage = this.$route.query.fromPage
      if (fromPage === 'invite-v2') {
        this.goPrevious()
        return
      }
      // 旧逻辑
      this.$router.replace({
        path: '/invite',
        query: {
          tab: 2,
        },
      })
    },

    // 刷新清除
    handleClear() {
      this.hostId = null
      this.chooseTime = null
      this.fetchData()
    },

    // 根据 id 刷选
    handleSearch() {
      this.fetchData()
    },

    // 根据时间刷选
    handleCurrentDate(time) {
      this.chooseTime = this.handleMoment(time, 'YYYY-MM-DD')
      this.fetchData()
    },
    fetchData() {
      this.listData = []
      this.listQuery.offset = 0
      this.fetchVioData()
    },

    // 下拉刷新
    onLoad() {
      this.fetchVioData()
    },

    // 获取列表数据
    fetchVioData() {
      this.loading = true
      const params = {
        hostPresentId: this.hostId,
        agentDay: this.chooseTime,
        ...this.listQuery,
      }
      apiFetchVioData(params).then((res) => {
        if (res) {
          this.loading = false
          this.totalDedWeek = res.weekPunishBeanSum
          this.totalVioWeek = res.weekPunishHostNum
          this.listData = this.listData.concat(res.punishRecordList)

          // mock-调试数据
          // this.listData = [
          //   {
          //     avatar: 'public/app/picture/240407/17124801063419b7cdeac-9ea6-4467-b9c8-d94bdc690d4d.jpg',
          //     locationFlag: 'public/picture/flag/BR.png',
          //     nickname: '1896hd',
          //     presentId: '6544976',
          //     state: 1,
          //     uid: 2474,
          //     punishReason: '阿语',
          //     punishTime: 1712480125000,
          //     punishAmount: 1000
          //   }
          // ]

          if (res.punishRecordList.length < this.listQuery.limit) {
            this.finished = true
          } else {
            this.finished = false
          }
          this.listQuery.offset = this.listData.length
        }
      })
    },

    // 复制id
    copyId(presentId) {
      this.handleCopy(presentId, this.$t('lang.BaseCommon.k071'))
    },

    // 跳转到规则页面
    handleToRule() {
      this.$router.push({ path: '/rules', query: { backType: 'previous' } })
    },

    // 打开日期选择
    handleTimePop() {
      this.showPop = true
    },

    // 关闭弹框
    closePop() {
      this.showPop = false
    },
  },
}
</script>
<style lang="scss" scoped>
.container-violation {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #f5f5fa;

  .custom-nav-block {
    background-color: #f5f5fa;
  }

  // --- .week-data-box > .week-data ---
  .week-data-box {
    width: 100%;
    height: 106px;
    margin: 20px 0;
    padding: 0 16px;
  }
  .week-data {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    align-content: center;
    justify-content: space-around;
    // --- .data > .num / .text ---
    .data {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .num {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--number-font);
        font-size: var(--fs-20);
        font-weight: var(--fw-500);
        line-height: var(--lh-title-20);
        color: #fc54ad;
        .img1,
        .img2 {
          width: 20px;
          height: 20px;
          margin-right: 3px;
        }
      }
      .text {
        width: 80px;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        font-weight: var(--fw-400);
        line-height: var(--lh-body-20);
        color: #666666;
        text-align: center;
      }
    }
    .line {
      width: 1px;
      height: 58px;
      margin-top: 24px;
      background: #e7e7e7;
    }
  }

  // --- .list-tit ---
  .list-tit {
    width: 100%;
    height: 26px;
    padding: 0 16px;
    font-family: var(--string-font);
    font-size: var(--fs-14);
    font-weight: var(--fw-600);
    color: #333333;
    line-height: var(--lh-title-24);
    font-style: normal;
  }

  // --- .list-search-box > .search-input | .search-select | .refresh ---
  .list-search-box {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    background: #f0f0f5;
    .search-input {
      flex: 1;
      position: relative;
      display: flex;
      align-items: center;
      height: 30px;
      .input {
        width: 100%;
        height: 30px;
        border-radius: 8px;
        background-color: #ffffff;
        color: #666;
        padding-left: 10px;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        line-height: var(--lh-label-16);
        &::placeholder,
        &::-webkit-input-placeholder {
          color: #c0c0c0;
          font-size: var(--fs-14);
          line-height: var(--lh-label-16);
        }
      }
      .search-icon {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
      }
    }
    .search-select {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 155px;
      height: 30px;
      margin: 0 8px;
      background: #ffffff;
      border-radius: 6px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-500);
      line-height: var(--lh-title-28);
      color: #666666;
      text-align: center;
      > img {
        width: 16px;
        margin-left: 4px;
      }
      .activeTime {
        transform: rotateX(180deg);
      }
    }
    .refresh {
      display: flex;
      align-items: center;
      > img {
        width: 24px;
        height: 24px;
      }
    }
  }

  // --- .list-header > .tableName ---
  .list-header {
    margin: 24px 0;
    display: flex;
    justify-content: space-around;
    .tableName {
      flex: 1;
      height: 16px;
      font-family: var(--string-font);
      font-size: var(--fs-12);
      font-weight: var(--fw-700);
      line-height: var(--lh-label-16);
      color: #333333;
      text-align: center;
      font-style: normal;
    }
  }

  // --- van-list.list-data-box > .list-data ---
  .list-data-box {
    display: block;
    width: 100%;
    height: calc(100vh - 449px);
    overflow-y: auto;
    padding-bottom: 10px;
    background-color: #f5f5fa;
    ::v-deep .van-list__finished-text {
      font-family: var(--string-font);
      font-size: var(--fs-12) !important;
      line-height: var(--lh-body-18) !important;
      color: #666 !important;
    }
  }
  .list-data {
    position: relative;
    width: 100%;
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-family: var(--string-font);
    font-size: var(--fs-14);
    line-height: var(--lh-body-20);
    color: #666;
    > div {
      flex: 1;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100vw - 32px);
      height: 1px;
      background: #e7e7ed;
    }
    // --- .list-data > .avatar-box ---
    .avatar-box {
      width: 52px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .avatar {
        width: 30px;
        height: 30px;
        margin-bottom: 2px;
        border-radius: 50%;
      }
      .copy-id {
        display: flex;
        align-items: center;
        .id {
          color: #999;
          font-size: var(--fs-10);
          line-height: var(--lh-label-14);
        }
        .copy {
          width: 10px;
          margin-left: 3px;
        }
      }
    }
    .opinion {
      width: 104px;
      text-align: center;
      word-wrap: break-word;
    }
    .time {
      text-align: center;
    }
    .beans-num {
      display: flex;
      align-items: center;
      justify-content: center;
      .beans {
        width: 16px;
        height: 16px;
      }
    }
  }
}

// --- RTL: mirror template tree under .container-violation ---
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-violation {
    .week-data {
      .data {
        .num {
          img {
            margin-right: 0;
            margin-left: 3px;
          }
        }
      }
    }
    .list-search-box {
      .search-input {
        .input {
          padding-left: 0;
          padding-right: 10px;
        }
        .search-icon {
          left: 10px;
          right: auto;
        }
      }
    }
    .list-data {
      .avatar-box {
        .copy-id {
          .copy {
            margin-left: auto;
            margin-right: 3px;
          }
        }
      }
    }
  }
}
</style>
